import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setDifferences,
    setDifferencesOff,
    setVisibleFeatures,
} from "../redux/modelsComparatorSlice";
import useGetTranslations from "../../../../../dealers/assets/js/dealers_map/hooks/useGetTranslations";

export default function Filters() {
    const [translations] = useGetTranslations(
        // locale,
        "/api/vehicles/get_translations/"
    );

    const dispatch = useDispatch();

    const [openModal, setOpenModal] = useState(false); // abre el modal de filtros en mobile
    const [all, setAll] = useState(true); // muestra todas las features (checkbox)

    const specifications = useSelector(
        (state) => state.modelsComparator.specifications
    );

    const typeAll = () => {
        dispatch(setDifferencesOff());
        document
            .querySelectorAll(".type-all")
            .forEach((e) => (e.checked = true));
        document
            .querySelectorAll(".type-diff")
            .forEach((e) => (e.checked = false));
    };

    const typeDiff = () => {
        dispatch(setDifferences());
        document
            .querySelectorAll(".type-all")
            .forEach((e) => (e.checked = false));
        document
            .querySelectorAll(".type-diff")
            .forEach((e) => (e.checked = true));
        showAll();
    };

    const closeModal = () => {
        // cierra el modal de filtros en mobile
        setOpenModal(false);
    };

    const showAll = () => {
        // muestra todas las features y destilda los otros checkbox
        dispatch(setVisibleFeatures("all"));
        setAll(true);
        document
            .querySelectorAll(".feature_checkbox")
            .forEach((e) => (e.checked = false));
    };

    const showFeature = (e) => {
        // muestra las features seleccionadas
        dispatch(setVisibleFeatures(e.target.name));
        setAll(false);
        typeAll();
    };

    const inputRadio = () => {
        return (
            <form>
                <div className="input">
                    <div
                        className="input__field --radio --border-none"
                        onClick={typeAll}
                    >
                        <input
                            className="input__field__radio type-all"
                            type="radio"
                            name="type-all"
                            value="type-all"
                            id="type-all"
                            defaultChecked
                        />
                        <label
                            htmlFor="type-all"
                            className="input__field__radio__label"
                        >
                            {translations.text7}
                        </label>
                    </div>
                </div>
                <div className="input">
                    <div
                        className="input__field --radio --border-none"
                        onClick={typeDiff}
                    >
                        <input
                            className="input__field__radio type-diff"
                            type="radio"
                            name="type-diff"
                            value="type-diff"
                            id="type-diff"
                        />
                        <label
                            htmlFor="type-diff"
                            className="input__field__radio__label"
                        >
                            {translations.text8}
                        </label>
                    </div>
                </div>
            </form>
        );
    };

    const inputCheckbox = () => {
        return (
            <form>
                <div className="input">
                    <div className="input__field --border-none --checkbox">
                        <input
                            className="input__field__checkbox"
                            type="checkbox"
                            name="all"
                            id="all"
                            onClick={showAll}
                            checked={all}
                        />
                        <label
                            htmlFor="all"
                            className="input__field__checkbox__label"
                            id="all"
                        >
                            {translations.text9}
                        </label>
                    </div>
                </div>

                {specifications !== []
                    ? specifications.map((feature, i) => {
                          if (feature) {
                              return (
                                  <div className="input" key={i}>
                                      <div className="input__field --border-none --checkbox">
                                          <input
                                              className="input__field__checkbox feature_checkbox"
                                              type="checkbox"
                                              name={feature}
                                              id={feature}
                                              onClick={showFeature}
                                          />
                                          <label
                                              htmlFor={feature}
                                              className="input__field__checkbox__label"
                                              id={feature}
                                          >
                                              {feature}
                                          </label>
                                      </div>
                                  </div>
                              );
                          }
                      })
                    : null}
            </form>
        );
    };

    return (
        <>
            <div className="comparator-filters">
                <p className="--text-m">
                    <strong>{translations.text10}</strong>
                </p>

                {inputRadio()}

                <p className="--text-s">
                    <strong>{translations.text11}</strong>
                </p>

                {inputCheckbox()}
            </div>

            <div className="comparator-filters-mobile">
                <button
                    className="comparator-filters-mobile__button"
                    onClick={() => setOpenModal(!openModal)}
                >
                    FILTRAR POR: (COmpARACIÓN COmpLETA)
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6 9L12 15L18 9"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>

                <div
                    className="comparator-filters-mobile__modal"
                    style={{ display: openModal ? "block" : "none" }}
                >
                    <div className="comparator-filters-mobile__modal__content">
                        <span className="modal-close">
                            <h5>{translations.text10}</h5>
                            <div onClick={closeModal}>✕</div>
                        </span>

                        {inputRadio()}

                        <p className="--text-m car">
                            <strong>{translations.text11}</strong>
                        </p>

                        {inputCheckbox()}
                    </div>
                </div>
            </div>
        </>
    );
}
